/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var column_list_component_1 = require("./column-list.component");
var column_chooser_component_1 = require("./column-chooser.component");
var column_menu_chooser_component_1 = require("./column-menu-chooser.component");
var column_menu_filter_component_1 = require("./column-menu-filter.component");
var column_menu_item_component_1 = require("./column-menu-item.component");
var column_menu_item_content_template_directive_1 = require("./column-menu-item-content-template.directive");
var column_menu_sort_component_1 = require("./column-menu-sort.component");
var column_menu_component_1 = require("./column-menu.component");
var column_menu_lock_component_1 = require("./column-menu-lock.component");
var filter_menu_module_1 = require("../filtering/menu/filter-menu.module");
var column_menu_template_directive_1 = require("./column-menu-template.directive");
var column_menu_container_component_1 = require("./column-menu-container.component");
var column_menu_item_directive_1 = require("./column-menu-item.directive");
var column_menu_stick_component_1 = require("./column-menu-stick.component");
var column_menu_position_component_1 = require("./column-menu-position.component");
var COMPONENTS = [
    column_list_component_1.ColumnListComponent,
    column_chooser_component_1.ColumnChooserComponent,
    column_menu_chooser_component_1.ColumnMenuChooserComponent,
    column_menu_filter_component_1.ColumnMenuFilterComponent,
    column_menu_item_component_1.ColumnMenuItemComponent,
    column_menu_item_content_template_directive_1.ColumnMenuItemContentTemplateDirective,
    column_menu_sort_component_1.ColumnMenuSortComponent,
    column_menu_component_1.ColumnMenuComponent,
    column_menu_lock_component_1.ColumnMenuLockComponent,
    column_menu_template_directive_1.ColumnMenuTemplateDirective,
    column_menu_container_component_1.ColumnMenuContainerComponent,
    column_menu_item_directive_1.ColumnMenuItemDirective,
    column_menu_stick_component_1.ColumnMenuStickComponent,
    column_menu_position_component_1.ColumnMenuPositionComponent
];
/**
 * @hidden
 */
var ColumnMenuModule = /** @class */ (function () {
    function ColumnMenuModule() {
    }
    ColumnMenuModule.exports = function () {
        return [
            column_chooser_component_1.ColumnChooserComponent,
            column_menu_filter_component_1.ColumnMenuFilterComponent,
            column_menu_item_component_1.ColumnMenuItemComponent,
            column_menu_item_content_template_directive_1.ColumnMenuItemContentTemplateDirective,
            column_menu_sort_component_1.ColumnMenuSortComponent,
            column_menu_lock_component_1.ColumnMenuLockComponent,
            column_menu_stick_component_1.ColumnMenuStickComponent,
            column_menu_position_component_1.ColumnMenuPositionComponent,
            column_menu_chooser_component_1.ColumnMenuChooserComponent,
            column_menu_template_directive_1.ColumnMenuTemplateDirective,
            column_menu_container_component_1.ColumnMenuContainerComponent,
            column_menu_item_directive_1.ColumnMenuItemDirective,
            column_menu_component_1.ColumnMenuComponent
        ];
    };
    ColumnMenuModule = tslib_1.__decorate([
        core_1.NgModule({
            declarations: [COMPONENTS],
            imports: [common_1.CommonModule, filter_menu_module_1.FilterMenuModule],
            exports: [COMPONENTS]
        })
    ], ColumnMenuModule);
    return ColumnMenuModule;
}());
exports.ColumnMenuModule = ColumnMenuModule;
